import * as React from "react"
import {MapState} from "./BookingDetails"

export interface RenderParams<T> {
  state: T
  mapState: MapState<T>
}

interface Props<T> {
  initialState: T
  render: (params: RenderParams<T>) => React.ReactNode
}

interface State<T> {
  state: T
}

export class StateContainer<T> extends React.Component<Props<T>, State<T>> {
  constructor(props: Props<T>) {
    super(props)
    this.state = {
      state: props.initialState,
    }
  }

  render() {
    return this.props.render({
      state: this.state.state,
      mapState: (fn) => {
        this.setState(({state}) => ({state: fn(state)}))
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/StateContainer.tsx